import * as yup from 'yup';
import emptyStringToNull from '../../functions/emptyStringToNull';

yup.setLocale({
  mixed: {
    required: 'This field is required',
    notType: (ref) => {
      return `Value must be a ${ref.type}`;
    },
  },
});

// createYupSchema is derived from
// "Creating dynamic validation schema":
// https://github.com/jquense/yup/issues/559#issuecomment-518953000

const createYupSchema = (schema, model) => {
  const localSchema = { ...schema };
  const { id, aliasName, validationType, validations } = model;
  if (!yup[validationType]) {
    return localSchema;
  }
  let validator = yup[validationType]().label(aliasName);

  if (validations) {
    validations.forEach((validation) => {
      const { params = [], type } = validation;
      if (!validator[type]) {
        return;
      }
      validator = validator[type](...params);
    });
  }

  if (validationType === 'number') {
    validator = validator.transform(emptyStringToNull);
    validator = validator.nullable();
  }

  localSchema[id] = validator;
  return localSchema;
};

const getSchema = (model) => {
  return Object.values(model).reduce(createYupSchema, {});
};

export default getSchema;
